export default "__VITE_ASSET__yWrm34Yx__"